module.exports = __webpack_public_path__ + "static/outlander-aa9bfe2e5b56d6f5d0f4edcf907ed336.jpg";